<!-- <h2 class="mt-3 ms-1 hidden-mobile">Ciao!</h2> -->
  <div 
    class="d-flex mt-3 ms-1 justify-content-between align-items-center hidden-mobile">
    <h2>Ciao!</h2>
    <div class="custom-select-wrapper">
      <mat-form-field appearance="fill" subscriptSizing="dynamic">
        <!-- <mat-label>Seleziona anno</mat-label> -->
        <mat-select
          [(value)]="selectedYear"
          (selectionChange)="onYearSelected($event)"
          matTooltip="Seleziona l'anno per cui visualizzare i dati."
        >
          <mat-option *ngFor="let year of years" [value]="year">
            {{ year }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

<mat-card class="mt-2 mb-2 text-button-card">
  <div class="card-content">
    <h5 class="card-text">
      <!-- Questa è la Dashboard di {{ (layoutService.organizationName$ | async) || "Organization" }}. -->
       Questa è la Dashboard di {{ organization_data?.name || "Organization" }}.
    </h5>

    <button
      mat-icon-button 
      color="primary"
      class="me-0 hidden-mobile custom-badge-blue"
      matTooltip="Apri notifiche e avvisi"
      (click)="navigateToMessages()"
    >
      <mat-icon 
        [matBadge]="messagesNumber" 
        [matBadgeHidden]="!messagesNumber || messagesNumber === 0" 
      >
        mail
      </mat-icon>
    </button>

    <button
      *ngIf="organization_data && organization_data.is_only_invoicing == false && organization_data.source === 'BEIZY'"
      mat-icon-button 
      color="primary"
      class="me-1 hidden-mobile custom-badge-yellow"
      matTooltip="Apri chat"
      (click)="navigateToChat()"
    >
      <mat-icon 
        [matBadge]="ticketsNumber" 
        [matBadgeHidden]="!ticketsNumber || ticketsNumber === 0" 
      >
        chat
      </mat-icon>
    </button>

    <button 
      mat-raised-button
      class="primary-button"
      matButton [matMenuTriggerFor]="menu"
      matButton="filled"
      matTooltip="Creazione rapida"
    >
      <mat-icon>add</mat-icon>
      Crea
    </button>
    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item (click)="navigateToNewInvoice()">
        <mat-icon>note_add</mat-icon>
        <span>Fattura</span>
      </button>
      <button mat-menu-item (click)="openQuickInvoice()">
        <mat-icon>bolt</mat-icon>
        <span>Fattura rapida</span>
      </button>
      <button mat-menu-item (click)="navigateToCreditNote()">
        <mat-icon>assignment_return</mat-icon>
        <span>Nota di credito</span>
      </button>
      <button mat-menu-item (click)="navigateToNewPreventive()">
        <mat-icon>content_paste_go</mat-icon>
        <span>Preventivo</span>
      </button>
      <button mat-menu-item (click)="navigateToNewCompany()">
        <mat-icon>person_add</mat-icon>
        <span>Cliente</span>
      </button>
      <button mat-menu-item (click)="navigateToNewSavedProduct()">
        <mat-icon>bookmark_add</mat-icon>
        <span>Prodotto/Servizio</span>
      </button>
    </mat-menu>
  </div>
</mat-card>

<mat-card
  *ngIf="unreadNotificationsCount > 0"
  class="mt-2 mb-2 text-button-card hidden-mobile"
>
  <div class="card-content">
    <p class="card-text mb-0">
      {{ unreadNotificationsLabel }}
    </p>

    <div class="d-flex align-items-center gap-2">
      <button
        *ngIf="messagesNumber > 0"
        mat-stroked-button
        class="notif-pill-button notif-pill-info"
        matTooltip="Apri notifiche e avvisi"
        (click)="navigateToMessages()"
      >
        <mat-icon>mail</mat-icon>
        Apri notifiche
      </button>

      <button
        *ngIf="ticketsNumber > 0 && canUseChat"
        mat-stroked-button
        class="notif-pill-button notif-pill-accent"
        matTooltip="Apri chat"
        (click)="navigateToChat()"
      >
        <mat-icon>chat</mat-icon>
        Apri chat
      </button>
    </div>
  </div>
</mat-card>

<!-- mobile version of year selection -->
<div class="d-flex mt-3 m-0 justify-content-between align-items-center visible-mobile custom-rounded">
  <div class="custom-select-wrapper">
    <mat-form-field appearance="fill" class="mb-0 w-100 custom-rounded" subscriptSizing="dynamic">
      <!-- <mat-label>Seleziona anno</mat-label> -->
      <mat-select
        class="custom-rounded"
        [(value)]="selectedYear"
        (selectionChange)="onYearSelected($event)"
        matTooltip="Seleziona l'anno per cui visualizzare i dati."
      >
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div *ngIf="ticketsNumber > 0" class="mt-3 mb-2 visible-mobile">
  <mat-card class="new-message-warning-card" (click)="navigateToChat()">
    <div class="mt-1 mb-1 ms-3">
      Hai <strong>{{ticketsNumber}}</strong> nuovi messaggi in chat.
    </div>
  </mat-card>
</div>

<div class="row mt-1 g-2">
  <!-- Added g-2 for consistent 0.5rem (8px) gap between columns -->
  <div class="col-md-8">
    <mat-card
      class="mb-2 mb-md-0 me-md-2 d-flex flex-column h-100 custom-card-green"
    >
      <mat-card-content class="p-0">
        <!-- Top Subcard -->
        <mat-card
          class="p-3 m-2 rounded-3 mb-2 clickable-green custom-card-green"
          (click)="navigateToInvoices()"
          matTooltip="Totale fatturato rispetto all'obiettivo dell'anno. Clicca per vedere le fatture."
        >
          <!-- Title: placeholder while loading, real title once done -->
          <h5 *ngIf="isLoading" class="card-title">Caricando dati...</h5>
          <h5 *ngIf="!isLoading && organization_data?.has_also_corrispettivi_receipts == false" class="card-title">Fatturato del {{selectedYear}}</h5>
          <h5 *ngIf="!isLoading && organization_data?.has_also_corrispettivi_receipts == true" class="card-title">Fatturato e corrispettivi del {{selectedYear}}</h5>

          <!-- Amount: hidden until all data is ready -->
          <p *ngIf="!isLoading" class="text-end fs-3 fw-bold mb-2">{{ formatAmount(totalAmount - totalCreditNotesAmount) }} €</p>
          <p *ngIf="isLoading" class="text-end fs-3 fw-bold mb-2 text-muted" style="opacity: 0.35;">— €</p>

          <!-- Progress bar: indeterminate while loading, determinate when done -->
          <mat-progress-bar
            [mode]="isLoading ? 'indeterminate' : 'determinate'"
            [value]="isLoading ? null : getProgressValue()"
            class="mb-2 custom-progress-bar"
          ></mat-progress-bar>

          <!-- Progress text: only when data is ready -->
          <div *ngIf="!isLoading" class="progress-text text-end">
            {{ formatAmount(totalAmount - totalCreditNotesAmount) }} € / {{ formatAmount(targetAmount) }} €
          </div>
          <div *ngIf="isLoading" class="progress-text text-end text-muted" style="opacity: 0.35;">
            — € / {{ formatAmount(targetAmount) }} €
          </div>
        </mat-card>

        <!-- Bottom Subcards Container -->
        <div class="d-flex flex-column">
          <!-- gap-2 gives consistent spacing -->
          <!-- First Bottom Subcard -->
          <mat-card
            class="p-3 m-2 rounded-3 clickable-green custom-card-green"
            (click)="navigateToInvoices()"
            matTooltip="Importo già incassato sul totale fatturato. Clicca per vedere le fatture."
          >
            <!-- Removed h-50, let flex handle height -->
            <h6 class="card-subtitle mb-md-2 mb-0">di cui hai incassato:</h6>
            <p class="text-end fs-4">{{  formatAmount(totalPaidAmount - totalCreditNotesPaidAmount) }} €</p>
          </mat-card>

          <!-- Second Bottom Subcard -->
          <!-- <div
            class="p-3 m-2 rounded-3 clickable-card custom-card"
            (click)="navigateToFiscalPlan()"
          >
            <h6 class="card-subtitle mb-2">Quanto pagherai</h6>
            <p class="text-end fs-4">24 €</p>
          </div> -->
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="mt-3 mobile-only-cards mobile-cards-container mb-2">
    <!-- Left column - two equal cards -->
    <div class="left-column">
      <mat-card class="mobile-card custom-card-yellow" (click)="navigateToNewCompany()">
        <mat-icon style="font-size: 24px; height: 24px; width: 24px;">person_add</mat-icon>
        <p class="mb-0">Nuovo cliente</p>
      </mat-card>
      
      <mat-card class="mobile-card custom-card-yellow" (click)="openQuickInvoice()">
        <mat-icon style="font-size: 24px; height: 24px; width: 24px;">bolt</mat-icon>
        <p class="mb-0">Fattura rapida</p>
      </mat-card>
    </div>

    <!-- Right column - one bigger card -->
    <mat-card class="mobile-card big-card custom-card-yellow" (click)="navigateToNewInvoice()">
      <mat-icon style="font-size: 48px; height: 48px; width: 48px;">add</mat-icon>
      <p class="mb-0">Nuova fattura</p>
    </mat-card>
  </div>

  <!-- only on mobile (notification badges ) -->
  <div 
    *ngIf="organization_data && organization_data.is_only_invoicing == false && organization_data.source === 'BEIZY'"
    class="mt-0 mb-0 visible-mobile">
    <mat-card class="mt-2 mb-2 text-button-card p-2">
      <div *ngIf="messagesNumber > 0 || ticketsNumber > 0" class="text-start mb-2">
        Ci sono notifiche o messaggi da leggere:
      </div>

      <div class="d-flex w-100">

        <div class="w-50 d-flex justify-content-center align-items-center">
          <button
            mat-icon-button
            color="primary"
            class="custom-badge-blue"
            matTooltip="Apri notifiche e avvisi"
            (click)="navigateToMessages()"
          >
            <mat-icon
              [matBadge]="messagesNumber"
              [matBadgeHidden]="!messagesNumber || messagesNumber === 0"
            >
              mail
            </mat-icon>
          </button>
        </div>

        <div class="border-start"></div>

        <div class="w-50 d-flex justify-content-center align-items-center">
          <button
            mat-icon-button
            color="primary"
            class="custom-badge-yellow"
            matTooltip="Apri chat"
            (click)="navigateToChat()"
          >
            <mat-icon
              [matBadge]="ticketsNumber"
              [matBadgeHidden]="!ticketsNumber || ticketsNumber === 0"
            >
              chat
            </mat-icon>
          </button>
        </div>

      </div>
    </mat-card>
  </div>

  <div class="col-md-4 mt-md-2 mt-2 mt-md-2">
    <mat-card class="mb-2 d-flex flex-column h-100 custom-card">
      <mat-card-content class="p-0 d-flex flex-column flex-grow-1 gap-2">
        <!-- Added flex-grow-1 -->
        <!-- Top Right Small Cards -->
        <div class="d-flex gap-2 m-2 mb-0 flex-grow-2 hidden-mobile equal-split">
          <mat-card
            class="p-2 clickable-yellow custom-card-yellow"
            (click)="openQuickInvoice()"
            matTooltip="Crea ed invia una fattura semplificata in pochi passaggi."
          >
            <div class="d-flex m-0 justify-content-between align-items-center">
              <div>
              <h5 class="card-title">Fattura rapida</h5>
              <p class="card-text">Invia fattura al volo</p>
              </div>
              <mat-icon>bolt</mat-icon>
            </div>
          </mat-card>

          <mat-card
            class="p-2 clickable-yellow custom-card-yellow"
            (click)="navigateToNewInvoice()"
            matTooltip="Crea una nuova fattura completa di tutti i dettagli."
          >
            <div class="d-flex m-0 justify-content-between align-items-center">
              <div>
              <h5 class="card-title">Fatturazione</h5>
              <p class="card-text">Crea una fattura.</p>
              </div>
              <!-- Right arrow icon -->
              <mat-icon>chevron_right</mat-icon>
            </div>
          </mat-card>
        </div>

        <!-- Bottom Right Small Card -->
        <div class="p-2 m-0 mt-0 flex-grow-1">
          <div class="h-100 d-flex flex-column">
            <h5 class="mb-3">Ultimi documenti emessi:</h5>
            <div class="flex-grow-1">
              <div *ngIf="lastThreeInvoices.length > 0" class="h-100">
                <div class="d-flex flex-column gap-2 h-100">
                  <mat-card
                    *ngFor="let invoice of lastThreeInvoices"
                    class="invoice-card"
                    (click)="onRowClick(invoice)"
                    [matTooltip]="(invoice.company?.company_name || 'N/A') + ' - ' + 'N.' + invoice.progressive_number + ' - ' + formatAmount(invoice.amount) + ' € - ' + (invoice.emission_date | date:'dd/MM/yyyy')"
                  >
                    <div class="d-flex align-items-center invoice-card-content">
                      <div class="invoice-icon">
                        <mat-icon>{{ invoice.document_type === 'TD04' ? 'assignment_return' : 'receipt' }}</mat-icon>
                      </div>
                      <span class="text-small invoice-company">{{ invoice.company?.company_name || 'N/A' }}</span>
                      <span class="ms-2 fw-bold text-small flex-shrink-0 invoice-amount">{{  formatAmount(invoice.amount) }} €</span>
                    </div>
                  </mat-card>
                </div>
              </div>
              <div *ngIf="isLoading" class="loading-container">
                <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
                <p class="mt-3">Caricando dati...</p>
              </div>
              <div *ngIf="lastThreeInvoices.length === 0 && isLoading === false" class="no-data-container h-100 d-flex align-items-center justify-content-center">
                <div class="text-center">
                  <mat-icon>money_off</mat-icon>
                  <p>Nessun dato disponibile.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="row g-2 mt-3 mb-0 visible-mobile">
  <div class="col-md-3">
    <mat-card 
      class="h-100 custom-card-blue"
      (click)="navigateToMessages()"
      >
        <!-- Changed mb-3 to mb-2 -->
        <mat-card-content class="p-0 m-2">
            <div class="card-body p-0">
              <!-- <h5 class="card-title">Messaggi da leggere</h5> -->
              <div class="mb-2 d-flex m-0 justify-content-between align-items-center">
                <p class="mb-0">Hai <strong>{{messagesNumber}}</strong> notifiche da leggere</p>
                <mat-icon class="me-1">mail</mat-icon>
              </div>
              <mat-card class="clickable-blue custom-card-blue">
                <mat-card-content class="p-0 m-1">
                  <div class="d-flex m-0 justify-content-between align-items-center">
                    Vai alla sezione
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
  </div>
</div>
<!-- 
<div class="row g-2 mt-3 mb-0 visible-mobile">
  <div class="col-md-3">
    <mat-card 
      class="h-100 custom-card-yellow"
      (click)="navigateToChat()"
      >
        <mat-card-content class="p-0 m-2">
            <div class="card-body p-0">
              <div class="mb-2 d-flex m-0 justify-content-between align-items-center">
                <p class="mb-0">Hai <strong>{{ticketsNumber}}</strong> chat da leggere</p>
                <mat-icon class="me-1">chat</mat-icon>
              </div>
              <mat-card class="clickable-yellow custom-card-yellow">
                <mat-card-content class="p-0 m-1">
                  <div class="d-flex m-0 justify-content-between align-items-center">
                    Vai alla sezione
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
  </div>
</div> -->

<!-- plots (line plot on mobile) -->
<div class="mt-3 row visible-mobile">
  <div class="col-md-12 mb-0">
    <izy-line-plot [selectedYear]="selectedYear"></izy-line-plot>
  </div>
</div>

<!-- Full width cards below -->
<div class="row g-2 mt-md-2 mt-0 mb-3">
  <!-- the Dichiarazione is not visible for only.invoicing members -->
  <div
      *ngIf="organization_data && organization_data.is_only_invoicing == false"
      class="col-md-3">
    <mat-card 
      class="h-100 custom-card-blue"
      (click)="navigateToDichiarazione()"
      >
        <!-- Changed mb-3 to mb-2 -->
        <mat-card-content class="p-0 m-2">
            <div class="card-body p-0">
              <h5 class="card-title">Dichiarazione dei Redditi</h5>
              <p>Disponibile a breve</p>
              <mat-card class="clickable-blue custom-card-blue">
                <mat-card-content class="p-0 m-1">
                  <div class="d-flex m-0 justify-content-between align-items-center">
                    Apri
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
  </div>

  <!-- only-invoicing members -->
  <div
      *ngIf="organization_data && organization_data.is_only_invoicing == true"
      class="col-md-3">
    <mat-card 
      class="h-100 custom-card-blue"
      (click)="navigateToPreventives()"
      >
        <!-- Changed mb-3 to mb-2 -->
        <mat-card-content class="p-0 m-2">
            <div class="card-body p-0">
              <h5 class="card-title">Preventivi</h5>
              <p>Crea preventivi in un lampo!</p>
              <mat-card class="clickable-blue custom-card-blue">
                <mat-card-content class="p-0 m-1">
                  <div class="d-flex m-0 justify-content-between align-items-center">
                    Vai alla sezione
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
  </div>

  <div class="col-md-9 mt-md-2 mt-3 mb-0">
    <mat-card 
      class="h-100 custom-card-pink"
      (click)="navigateToFiscalPlan()"
      >
        <!-- Changed mb-3 to mb-2 -->
        <mat-card-content class="p-0 m-2">
            <div class="card-body p-0">
              <h5 class="card-title">Pianificazione fiscale</h5>
              <p>Secondo il nostro simulatore, per l'anno {{nextYear}} pagherai {{ formatAmount(nextYearTotalAmountTasse) }}€ di tasse e {{ formatAmount(nextYearTotalAmountContributi) }}€ di contributi.</p>
              <mat-card class="clickable-pink custom-card-pink">
                <mat-card-content class="p-0 m-1">
                  <div class="d-flex m-0 justify-content-between align-items-center">
                    Apri la sezione
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
          </div>
        </mat-card-content>
    </mat-card>
  </div>

</div>


<!-- plots (line plot on desktop) -->
<div class="row hidden-mobile">
  <div class="col-md-12 mb-0">
    <izy-line-plot [selectedYear]="selectedYear"></izy-line-plot>
  </div>
</div>


<!-- Invoice Simulator  -->
<div class="mb-0 mb-md-0 mt-md-3">
  <mat-card class="h-100 custom-card">
    <mat-card-content class="p-3" [formGroup]="simulatorForm">
      <h5 class="card-title mb-2">Simulatore Regime Forfettario</h5>
      <p class="mb-3"><i>"Se emetto questa fattura, quanto mi rimane in tasca?"</i></p>

      <div class="d-flex align-items-center gap-2 hidden-mobile">
        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>Totale Lordo Fattura (€)</mat-label>
          <input matInput type="tel" formControlName="total" min="0" maxlength="9"
            matTooltip="Totale lordo della fattura">
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>Coeff. Redditività (%)</mat-label>
          <input matInput type="number" formControlName="coefficient"
            matTooltip="Questo valore viene calcolato sulla base del codice ATECO">
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>Imposta (%)</mat-label>
          <input matInput type="number" formControlName="taxRate" 
            matTooltip="Questo valore viene calcolato sulla base del tipo di Organizzazione (aliquota del 5 o 15% per l'Imposta Sostitutiva)">
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>Previdenza (%)</mat-label>
          <input matInput type="number" formControlName="pensionRate"
            matTooltip="Questo valore viene calcolato in base alla cassa previdenziale di appartenenza">
        </mat-form-field>
      </div>

      <!-- mobile version  -->
      <div class="visible-mobile">
  
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Totale Lordo Fattura (€)</mat-label>
          <input matInput type="tel" formControlName="total" min="0" maxlength="9"
             matTooltip="Totale lordo della fattura">
        </mat-form-field>

        <div class="d-flex gap-2">
          
          <mat-form-field appearance="outline" style="flex: 1; min-width: 0;">
            <mat-label>Coeff. (%)</mat-label>
            <input matInput type="number" formControlName="coefficient"
              matTooltip="Questo valore viene calcolato sulla base del codice ATECO">
          </mat-form-field>

          <mat-form-field appearance="outline" style="flex: 1; min-width: 0;">
            <mat-label>Imposta (%)</mat-label>
            <input matInput type="number" formControlName="taxRate"
              matTooltip="Questo valore viene calcolato sulla base del tipo di Organizzazione (aliquota del 5 o 15% per l'Imposta Sostitutiva)">
          </mat-form-field>

          <mat-form-field appearance="outline" style="flex: 1; min-width: 0;">
            <mat-label>Prev. (%)</mat-label>
            <input matInput type="number" formControlName="pensionRate"
              matTooltip="Questo valore viene calcolato in base alla cassa previdenziale di appartenenza">
          </mat-form-field>

        </div>
      </div>

      <hr>

      <div class="d-flex w-100 text-small mt-3 hidden-mobile align-items-center">
  
        <div class="w-25 text-start">
          <span class="text-muted">Base Imponibile:</span><br>
          <strong class="text-muted">({{ formatAmount(taxableAmount) }} €)</strong>
        </div>

        <div class="w-25 text-start">
          <span class="text-muted">Imposta (-):</span><br>
          <strong class="text-danger">{{ formatAmount(taxesAmount) }} €</strong>
        </div>

        <div class="w-25 text-start">
          <span class="text-muted">Contributi (-):</span><br>
          <strong class="text-danger">{{ formatAmount(pensionAmount) }} €</strong>
        </div>

        <div class="w-25 text-end">
          <span class="primary-text font-weight-bold">Netto in tasca:</span><br>
          <h5 class="primary-text m-0"><strong>{{ formatAmount(finalResult) }} €</strong></h5>
        </div>

      </div>

      <div class="d-flex text-small mt-2 visible-mobile">
        <div class="d-flex justify-content-between align-items-center text-muted">
          <span>Base Imponibile: </span>
          <span><strong>({{ formatAmount(taxableAmount) }} €)</strong></span>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <span>Imposta (-):</span>
          <span><strong>-{{ formatAmount(taxesAmount) }} €</strong></span>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <span>Contributi (-):</span>
          <span><strong>-{{ formatAmount(pensionAmount) }} €</strong></span>
        </div>
        <div class="primary-text d-flex justify-content-between align-items-center">
          <span>Risultato (netto in tasca):</span>
          <span><strong>{{ formatAmount(finalResult) }} €</strong></span>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>

<!-- Full width cards below -->
<div class="row g-3 mt-0 mb-3">
  <div class="col-md-6 hidden-mobile">
    <mat-card 
      class="h-100 custom-card-blue"
      (click)="navigateToTutorials()"
      >
        <!-- Changed mb-3 to mb-2 -->
        <mat-card-content class="p-0 m-2">
            <div class="card-body p-0">
              <!-- <h5 class="card-title">Messaggi da leggere</h5> -->
              <div class="mb-2 d-flex m-0 justify-content-between align-items-center">
                <p class="mb-0">Hai bisogno di aiuto?</p>
                <mat-icon class="me-1">help</mat-icon>
              </div>
              <mat-card class="clickable-blue custom-card-blue">
                <mat-card-content class="p-0 m-1">
                  <div class="d-flex m-0 justify-content-between align-items-center">
                    Vai alla nostra sezione tutorial
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
  </div>

  <div class="col-md-6 hidden-mobile">
    <mat-card 
      class="h-100 custom-card-blue"
      (click)="navigateToMessages()"
      >
        <!-- Changed mb-3 to mb-2 -->
        <mat-card-content class="p-0 m-2">
            <div class="card-body p-0">
              <!-- <h5 class="card-title">Messaggi da leggere</h5> -->
              <div class="mb-2 d-flex m-0 justify-content-between align-items-center">
                <p class="mb-0">Hai <strong>{{messagesNumber}}</strong> nuove notifiche da leggere</p>
                <mat-icon class="me-1">mail</mat-icon>
              </div>
              <mat-card class="clickable-blue custom-card-blue">
                <mat-card-content class="p-0 m-1">
                  <div class="d-flex m-0 justify-content-between align-items-center">
                    Vai alla sezione
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- plots -->
<div class="row">
  <div class="col-md-6 mb-2 mt-0">
    <app-bar-plot [selectedYear]="selectedYear"></app-bar-plot>
  </div>
  <div class="col-md-6 mb-2 mt-md-0 mt-3">
    <app-pie-chart [selectedYear]="selectedYear"></app-pie-chart>
  </div>
</div>

<div class="row g-2 mt-3 mb-0 visible-mobile">
  <div class="col-md-3">
    <mat-card 
      class="h-100 custom-card-blue"
      (click)="navigateToTutorials()"
      >
        <!-- Changed mb-3 to mb-2 -->
        <mat-card-content class="p-0 m-2">
            <div class="card-body p-0">
              <!-- <h5 class="card-title">Messaggi da leggere</h5> -->
              <div class="mb-2 d-flex m-0 justify-content-between align-items-center">
                <p class="mb-0">Hai bisogno di aiuto?</p>
                <mat-icon class="me-1">help</mat-icon>
              </div>
              <mat-card class="clickable-blue custom-card-blue">
                <mat-card-content class="p-0 m-1">
                  <div class="d-flex m-0 justify-content-between align-items-center">
                    Vai alla nostra sezione tutorial
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
  </div>
</div>


<div class="pt-3 mb-3"></div>
